import Layout from '../abstracts/Layout';

/*
 * Layout classes are usefull to page related behaviors
*/

export default class TestLayout extends Layout{
	constructor(){
		console.log('TestLayout init');
		super();
	}
}
